"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagManager = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const index_1 = require("./index");
const FeatureFlagManager = (props) => {
    if (!(0, index_1.checkFeatureFlag)(props.flag)) {
        if (props.fallback) {
            return props.fallback;
        }
        return null;
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children });
};
exports.FeatureFlagManager = FeatureFlagManager;
//# sourceMappingURL=featureFlagManager.js.map